<template>
  <div class="navbar">
    <div class="navbar-left">
      <span>新旅视界</span>
    </div>
    <div class="navbar-right">
      <!-- <el-dropdown @command="handleCommand">
        <span class="el-dropdown-link d-cen1">
          <span> {{ userInfo.brandName }}</span>

          <el-icon style="margin-left: 10px">
            <caret-bottom />
          </el-icon>
        </span>
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item command="logout"> 退出登录 </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown> -->
    </div>
  </div>
</template>

<script setup>
import { ref } from "vue";
import { useRouter } from "vue-router";
import { ElMessage } from "element-plus";

const userInfo = ref({}); // 默认选中的账号
userInfo.value = JSON.parse(localStorage.getItem("userInfo"));

const router = useRouter();

const handleCommand = (command) => {
  if (command === "profile") {
    // 处理个人中心逻辑
    ElMessage({
      message: "跳转到个人中心",
      type: "info",
    });
    router.push({ path: "/profile" }); // 假设个人中心的路径是 /profile
  } else if (command === "logout") {
    // 处理退出登录逻辑
    ElMessage({
      message: "退出登录",
      type: "success",
    });
    // 清除本地存储的 token 和用户信息
    localStorage.removeItem("token");
    localStorage.removeItem("userInfo");
    router.replace({ path: "/login" }); // 跳转到登录页面
  }
};
</script>

<style scoped>
.navbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 76px;
  background-color: #fff;
  padding: 0 40px;
}

.navbar-left {
  font-weight: 500;
  font-size: 20px;
  color: #283e62;
}

.navbar-right {
  cursor: pointer;
}

.el-dropdown-link {
  color: #000;
  font-size: 17px;
  font-weight: bold;
  color: #000000;
}
</style>
